import Auth_page from './views/auth/auth_page.vue';
import Login_page from './views/auth/login_page.vue';
import Home_page from './views/home_page.vue';
import varibox_page from './views/main/varibox_page.vue';

import Not_found from './views/other/not_found.vue';

export const routes = [
 //{ path: '/', component: Home_page, meta: { requiresAuth: true } },
  { path: '/', component: Home_page },

  { path: '/auth', component: Auth_page },
  { path: '/auth/sign-in', component: Login_page },

  { path: '/varibox', component: varibox_page},

  { path: '/:pathMatch(.*)*', name: 'NotFound', component: Not_found }
];